/**
 * Created by jpilz on 2/13/17.
 */
"use strict";
import {context} from '../../../objects/context.js';
import $ from 'jquery';
import ko from 'knockout';

import optionsUtil from '../../../objects/optionsUtil.js';
import editorStyleObj from '../../../objects/editorStyleObj';
//import enableCM from 'knockout-code-mirror';
//import CodeMirror from 'code-mirror';

class editorStylesEditorModel {

    constructor() {
        // Profile
        this.componentName = "editorStylesEditor";
        this.context = context;
        this.id = this.context.util.guid();
        this.sampleId = this.context.util.guid();
        this.visible = ko.observable(true);
        this.title = ko.observable("Master Style Editor");

        this.addUpdateTitle = ko.observable("Add");

        this.selectedItemID = ko.observable(0);
        this.selectedItem = ko.observable(this.returnDefaultItem()).extend({ notify: 'always' });
        this.filterCommonTagsOnly = ko.observable(true);

        this.contentVisible = ko.observable(false);
        this.listArray = ko.observableArray([]);

        //Editor
        this.editorId = this.context.util.guid();

        console.log("editorStylesEditor:constructor this: %o", this);
        
    }

    toggleContent() {

        this.contentVisible(!this.contentVisible());

        if(this.contentVisible())
        {
            this.getData();
            console.log("title: %s", this.title());
            console.log(this.listArray);
        }
    }

    returnDefaultItem() {
        return { "id" : null, "partnerid" : null, "subid" : "", "elementname" : null, "stylecode" : "{ sample }", "createdate" : null, "sort" : null, "standard": null};
        //return retnObj;
    }

    getData() {

        let oUtil = new optionsUtil(this.context);

        this.listArray([]);
        let self = this;

        oUtil.getMasterStyles().then( (result) => {
            //self.context.masterStyleSheet(result);
            ko.utils.arrayForEach(result, (item) => {
                console.log("editorStylesEditor:getData item: %o", item);
                if((self.filterCommonTagsOnly() === true) && (item.standard === 1))
                {
                    console.log("common Only");
                    let tempStyle = new editorStyleObj(item);
                    self.listArray.push(tempStyle);
                } 
                else if(self.filterCommonTagsOnly() === false)
                {
                    console.log("All Styles");
                    let tempStyle = new editorStyleObj(item);
                    self.listArray.push(tempStyle);
                }
                
            });

            console.log(this.listArray());
        });

        self.listArray.valueHasMutated();
        console.log("editorStylesEditor:getData listArray: %o", self.listArray());

    }

    saveStyle() {
        console.log("editorStylesEditor:saveStyle selectedObject: %o", this.selectedItem());

        let oUtil = new optionsUtil(this.context);
        //let self = this;

        oUtil.updateMasterStyles(this.selectedItem()).
        then( (rtnData) => {
            console.log("editorStylesEditor:saveStyle: result: %o, request: %o", rtnData.result, rtnData.request);
            if(rtnData.request.status !== 200)
            {
                console.log("editorStylesEditor:saveStyle:Error: result: %o", rtnData.result);
                this.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Error processing updateInlineStyles: " + rtnData.result},"messageModel");
            }
            else
            {
                console.log("editorStylesEditor:saveStyle:Success: result: %o", rtnData.result);
                this.context.eventManager.notifySubscribers(null,"styleSheetChanged");
            }
        });

    }

    restoreMasterStyle() {
        console.log("editorStylesEditor:restoreMasterStyle");

        let oUtil = new optionsUtil(this.context);

        oUtil.restoreMasterStyles().
        then( (rtnData) => {

            console.log("editorStylesEditor:restoreMasterStyle: result: %o, request: %o", rtnData.result, rtnData.request);
            if(rtnData.request.status !== 200)
            {
                console.log("editorStylesEditor:restoreMasterStyle:Error: result: %o", rtnData.result);
                this.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Error processing editorStylesEditor:restoreMasterStyle " + rtnData.result},"messageModel");
            }
            else
            {
                console.log("editorStylesEditor:restoreMasterStyle:Success: result: %o", rtnData.result);
                this.context.eventManager.notifySubscribers({modalTitle:"Master Style Restore",modalBody:"Your current style has been restored."},"messageModel");
                this.context.eventManager.notifySubscribers(null,"styleSheetChanged");
                this.getData();
            }
            
        });

    }

    backupMasterStyle() {
        console.log("editorStylesEditor:backupMasterStyle");

        let oUtil = new optionsUtil(this.context);
        //let self = this;

        oUtil.backupMasterStyles().
        then( (rtnData) => {

            console.log("editorStylesEditor:backupMasterStyle: result: %o, request: %o", rtnData.result, rtnData.request);
            if(rtnData.request.status !== 200)
            {
                console.log("editorStylesEditor:backupMasterStyle:Error: result: %o", rtnData.result);
                this.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Error processing editorStylesEditor:backupMasterStyle " + rtnData.result},"messageModel");
            }
            else
            {
                console.log("editorStylesEditor:backupMasterStyle:Success: result: %o", rtnData.result);
                this.context.eventManager.notifySubscribers({modalTitle:"Master Style Backup",modalBody:"Your current style has been backup."},"messageModel");
                //this.context.eventManager.notifySubscribers(null,"styleSheetChanged");
            }

        });

    }

    handleClick(model,item) {

        console.log("editorStylesEditor:handleClick");
        console.log(model);
        console.log(item);

        let selectedIndex = item.target.selectedIndex -1;

        this.selectedItem(this.listArray()[selectedIndex]);
        this.selectedItem.valueHasMutated();
        
        console.log("editorStylesEditor:getData selectedIndex: %i, selectedItem: %o", selectedIndex, this.selectedItem());

        this.updateStyle(this.selectedItem().getCleanStyle());

    }

    handleFilterClick() {
        console.log("editorStylesEditor:handleFilterClick filterCommonTagsOnly: %o", this.filterCommonTagsOnly());
        this.getData();
    }
    
    updateCode(vm) {
        console.log("editorStylesEditor:updateCode: vm: %o", vm);
        //console.log(vm);
        
        let editor =  $('#' + vm.editorId + ' .CodeMirror')[0].CodeMirror;
        console.log("editorStylesEditor:updateCode: editor: %o", editor);
        console.log(editor.getValue());

        vm.selectedItem().stylecode(editor.getValue());
        this.updateStyle(vm.selectedItem().getCleanStyle());

        console.log("editorStylesEditor:updateCode: vm.selectedItem(): %o", vm.selectedItem());


        //vm.updateHelp("A refresh is required to enable these changes.")
        
    }

    updateStyle(style) {
        $('#' + this.sampleId).attr('style' , '' + style + '');
    }

    

}

export default { viewModel: editorStylesEditorModel, template: require('!raw-loader!./editorStylesEditor.html') };


// WEBPACK FOOTER //
// ./src/components/options/editorStylesEditor/editorStylesEditor.js